export const setExcludedList = (list, word) => {
  //고객사례, 뉴스에서 디케이테크인 카테고리 미노출 처리
  const exclude = (item) => {
    return item.name !== word;
  };
  const excludedList = list.filter(exclude);
  return excludedList;
};
